import { currentDevice } from '../../core/utils/currentDevice'
import { getPrefix } from '../../core/utils/locale.js'
import Modal from '../../shared/modal/modal'
import { readCookie } from '../../utils/cookie_manager'
import { getLazyData } from '../../utils/get_lazy_data'
import { createAndShowHtmlSheet } from '../bottom_sheet/bottom_sheet.js'

import { initializeUtagEvents } from './phone_list_analytics.js'

export const CALL_CENTER_MODAL_OPEN_EVENT = 'call-center-modal:open'
export const CALL_CENTER_MODAL_CLOSE_EVENT = 'call-center-modal:close'

if (currentDevice.isMobile) {
  import('./phone_list_mobile.scss')
} else {
  import(`./phone_list.scss`)
}

const isFhiPage = document.querySelector('html').dataset.fhiTest !== undefined
$(function () {
  let opened = false
  const callCenterLinks = document.querySelectorAll('.js-call-center-modal')

  callCenterLinks.forEach(element => {
    element.addEventListener('click', e => {
      e.preventDefault()
      const utagStructure = e.currentTarget.dataset.utagStructure

      const threeMoreRooms = e.target.classList.contains('js-three-more-rooms')
      openCallCenterPopup(false, threeMoreRooms, utagStructure)
    })
  })

  $(document).on('click', '.show-phone-numbers-404', function (e) {
    e.preventDefault()
    e.stopPropagation()
    if (!opened) openCallCenterPopup(true)
  })

  $(document).on('click', '.phone-list-see-numbers', function () {
    if (!opened) openCallCenterPopup(true)
    if ($(this).data('show') == true) {
      $('.phone-list-number').hide()
      $('.phone-list-row').hide()
      $('.phone-list-email').hide()
      $('.phone-list-numbers').show()
      return true
    }
    $('.phone-list-number').show()

    hidePhoneList()
  })

  $(document).on('click', '.show-phone-numbers', function () {
    $('.mobile-call-center').trigger('click')
    $('.phone-list-see-numbers').trigger('click')
    $('.phone-list-number').hide()
    $('.phone-list-row').hide()
    $('.phone-list-email').hide()
  })

  function onOpenCallCenterPopup(container, popupInstance, utagStructure) {
    if (isFhiPage) return

    const callCenterContainer = container.querySelector('.js-call-center-content')

    if (callCenterContainer) {
      callCenterContainer.classList.remove('hidden')
    }
    if (utagStructure) {
      container.classList.add(utagStructure)
    }
    initializeUtagEvents()

    // Close popup when user opens Call Me Back Modal
    const callMeBackButton = container.querySelector('.js-show-call-me-back-modal')
    callMeBackButton?.addEventListener('click', function () {
      popupInstance && popupInstance.close()
    })
  }

  function openCallCenterPopup(showNumbers = false, threeMoreRooms = false, utagStructure = false) {
    opened = true
    const htmlTag = document.documentElement
    const country = readCookie('x-country')
    const marketId = htmlTag.dataset.marketId
    const site = IB.is_in_microsite ? htmlTag.dataset.inMicrosite : 'iberostar'
    const force_cc = false
    const url = `${getPrefix()}/ajax_contents/lightbox_callcenter/?country=${country}&market_id=${marketId}&site=${site}&force=${force_cc}&showNumbers=${showNumbers}&three_more_rooms=${threeMoreRooms}`

    getLazyData(url, function (contactHtml) {
      if (currentDevice.isMobile) {
        createAndShowHtmlSheet({
          html: contactHtml,
          onShow: (sheet, sheetInstance) => {
            onOpenCallCenterPopup(sheet, sheetInstance, utagStructure)
          },
          onClose: () => {
            opened = false
          },
        })
      } else {
        Modal.showHtml({
          title: 'Contact',
          html: contactHtml,
          onShow: modal => {
            if (!isFhiPage) {
              ScrollLock.on()
              onOpenCallCenterPopup(modal, Modal, utagStructure)
            }
          },
          onClose() {
            ScrollLock.off()
            opened = false
          },
          awaitCloseAnimation: true,
        })
      }
    })
  }

  function hidePhoneList() {
    $('.phone-list-numbers').hide()
    $('.phone-list-row').show()
    $('.phone-list-email').show()
  }

  window.IB.phone_list = {
    openCallCenterPopup,
  }
})
